<template>
  <div class="hello uk-container">
    <div class="content-area">
      <div class="uk-grid">
        <div class="uk-width-1-3">
          <h4>{{ title }}</h4>
          <p v-if="hasDesc">{{ desc }}</p>
          <p>{{ msg }}</p>
        </div>
        <div class="uk-width-2-3">
          <ul class="uk-tab uk-margin-small-bottom">
            <li v-for="(example, index) in examples" :class="{ 'uk-active': index == activeTab }">
              <a href="#" @click.prevent="switchExample(index)">{{ exampleLabel(index) }}</a>
            </li>
          </ul>
          <img :style="imageStyle" :src="url" />
        </div>
      </div>
    </div>
    <div class="sidebar uk-margin-bottom">
      <ul class="uk-nav">
        <li class="uk-nav-header">Fixation</li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','arthrodesis'])">Arthrodesis</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','bladeplate'])">Blade Plate</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','cast'])">Cast</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','cerclage_bands'])">Cerclage Bands</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','cerclage'])">Cerclage Wires</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','dynamic'])">Dynamic Compression Screw</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','exfix'])">External Fixation</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','hagie'])">Hagie Pin</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','imnail'])">Intramedullary Nail</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','percutaneous_pin'])">Percutaneous Pin</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','platescrew'])">Plate &amp; Screw</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','screws'])">Screws &amp; Pins</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','spiral'])">Spiral Blade</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','splint'])">Splint</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','syndesmotic'])">Syndesmotic Screw</a></li>
        <li><a href="#" @click.prevent="switchSubject(['fixation','tension'])">Tension &amp; K Wires</a></li>
        <li class="uk-nav-header">Ankle</li>
        <li><a href="#" @click.prevent="switchSubject(['ankle','arthroplasty'])">Arthroplasty</a></li>
        <li class="uk-nav-header">Elbow</li>
        <li><a href="#" @click.prevent="switchSubject(['elbow','arthroplasty'])">Arthroplasty</a></li>
        <li class="uk-nav-header">Foot</li>
        <li><a href="#" @click.prevent="switchSubject(['foot','duvries'])">DuVires Arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['foot','lapiplasty'])">Lapiplasty</a></li>
        <li class="uk-nav-header">Hip</li>
        <li><a href="#" @click.prevent="switchSubject(['hip','spacer'])">Articulating Antibiotic Spacer</a></li>
        <li><a href="#" @click.prevent="switchSubject(['hip','unipolar'])">Unipolar Hemi-arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['hip','bipolar'])">Bipolar Hemi-arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['hip','total'])">Total Arthroplasty</a></li>
    <!-- No cement picture!
        <li><a href="#" @click.prevent="switchSubject(['hip','cemented'])">Cemented Total Arthroplasty</a></li>
      -->
        <li class="uk-nav-header">Knee</li>
        <li><a href="#" @click.prevent="switchSubject(['knee','acl'])">ACL Repair</a></li>
        <li><a href="#" @click.prevent="switchSubject(['knee','femoral'])">Femoral Replacement</a></li>
        <li><a href="#" @click.prevent="switchSubject(['knee','unicompartmental'])">Unicompartmental Arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['knee','nostemtotal'])">Total Arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['knee','pclsparing'])">Nonconstrained Arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['knee','semiconstrained'])">Semiconstrained Arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['knee','constrained'])">Constrained Arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['knee','static'])">Static Antibiotic Spacer</a></li>
        <li class="uk-nav-header">Shoulder</li>
        <li><a href="#" @click.prevent="switchSubject(['shoulder','resurfacing'])">Resurfacing Hemi-arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['shoulder','reverse'])">Reverse Total Arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['shoulder','total'])">Total Arthroplasty</a></li>
        <li class="uk-nav-header">Spine</li>
        <li><a href="#" @click.prevent="switchSubject(['spine','acdf'])">Anterior Fusion</a></li>
        <li><a href="#" @click.prevent="switchSubject(['spine','postfusion'])">Posterior Fusion</a></li>
        <li><a href="#" @click.prevent="switchSubject(['spine','bonegraft'])">Bone Graft</a></li>
        <li><a href="#" @click.prevent="switchSubject(['spine','discarthroplasty'])">Disc Arthroplasty</a></li>
        <li><a href="#" @click.prevent="switchSubject(['spine','interbodycage'])">Interbody Cage</a></li>
        <li><a href="#" @click.prevent="switchSubject(['spine','laminoplasty'])">Laminoplasty</a></li>
        <li class="uk-nav-header">Failure</li>
        <li><a href="#" @click.prevent="switchSubject(['failure','arthrofibrosis'])">Arthrofibrosis</a></li>
        <li><a href="#" @click.prevent="switchSubject(['failure','dislocation'])">Dislocation</a></li>
        <li><a href="#" @click.prevent="switchSubject(['failure','hardwarefx'])">Hardware Fracture</a></li>
        <li><a href="#" @click.prevent="switchSubject(['failure','heterotopic'])">Heterotopic Bone</a></li>
        <li><a href="#" @click.prevent="switchSubject(['failure','loosening'])">Osteolysis/Loosening</a></li>
        <li><a href="#" @click.prevent="switchSubject(['failure','particle'])">Particle Disease</a></li>
        <li><a href="#" @click.prevent="switchSubject(['failure','periprostheticfx'])">Periprosthetic Fracture</a></li>
        <li><a href="#" @click.prevent="switchSubject(['failure','wear'])">Polyethylene Wear</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import ImageMeta from '../ImageMeta.js'
export default {
  name: 'main',
  data () {
    return {
      activeTab: 0,
      imageStyle: {
        maxHeight: '' + (window.innerHeight - 80 - 20 - 32) + 'px'   // viewport height minus navbar, margin, and tabs
      },
      examples: ImageMeta.fixation.percutaneous_pin.examples,
      title: ImageMeta.fixation.percutaneous_pin.title,
      desc: undefined
    }
  },
  computed: {
    msg: function () {
      return this.examples[this.activeTab].caption
    },
    url: function () {
      return 'static/imgs/' + this.examples[this.activeTab].url
    },
    hasDesc: function () {
      return this.desc !== undefined
    }
  },
  methods: {
    exampleLabel: function (index) {
      var prefix = this.examples.length < 5 ? 'Example ' : ''
      return prefix + (index + 1)
    },
    switchExample (index) {
      this.activeTab = index
    },
    switchSubject (newExamples) {
      this.examples = ImageMeta[newExamples[0]][newExamples[1]].examples
      this.title = ImageMeta[newExamples[0]][newExamples[1]].title
      this.desc = ImageMeta[newExamples[0]][newExamples[1]].description
      this.activeTab = 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-area {
  padding-right: 280px;
}

.sidebar {
  position: fixed;
  width: 260px;
  right: 0;
  bottom: 0;
  top: 81px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Reference.vue